/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLayersUnion = createReactComponent("layers-union", "IconLayersUnion", [
  [
    "path",
    {
      d: "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2v-2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2",
      key: "svg-0"
    }
  ]
]);

export { IconLayersUnion as default };
//# sourceMappingURL=IconLayersUnion.js.map
